<template>
  <div class="user">
    <div class="sidebar">
      <div class="info">
        <div class="avatar">
          <el-image class="img" :src="user.userPhoto" fit="cover"></el-image>
        </div>
        <p class="name">{{user.userName}}</p>
        <p class="summary">
          <!-- <span class="cell">高二</span>
          <span class="cell">福建</span>
          <span class="cell">福州</span> -->
        </p>
        <!-- <p class="level" v-if="user.userType === 20">A级老师</p> -->
      </div>
      <div class="nav">
        <router-link to="/user/info" active-class="on" class="nav-cell" v-if="user.userType === 10">{{$t('account')}}</router-link>
        <router-link to="/user/info2" active-class="on" class="nav-cell" v-if="user.userType === 20">{{$t('account')}}</router-link>
        <router-link to="/prestore" active-class="on" class="nav-cell" v-if="user.userType === 10 && user.state===1">{{$t('pre')}}</router-link>
        <router-link to="/user/myteacher" active-class="on" class="nav-cell" v-if="user.userType === 10">{{$t("myteacher")}}</router-link>
        <router-link to="/user/timetable" active-class="on" class="nav-cell" v-if="user.userType === 10">{{$t('timetable')}}</router-link>
        <router-link to="/user/timetable2" active-class="on" class="nav-cell" v-if="user.userType === 20">{{$t('timetable')}}</router-link>
        <router-link to="/user/courses" active-class="on" class="nav-cell" v-if="user.userType === 10">{{$t('end')}}</router-link>
        <router-link to="/user/courses2" active-class="on" class="nav-cell" v-if="user.userType === 20">{{$t('end')}}</router-link>
        <router-link to="/user/myStudent" active-class="on" class="nav-cell" v-if="user.userType === 20">{{$t('myStudent')}}</router-link>
        <router-link to="/user/news" active-class="on" class="nav-cell" v-if="user.state===1">{{$t('msg')}}</router-link>
        <router-link to="/user/income" active-class="on" class="nav-cell" v-if="user.userType === 20">{{$t('income')}}</router-link>
        <router-link to="/user/changepsw" active-class="on" class="nav-cell">{{$t("common.change")}}</router-link>
      </div>
    </div>
    <div class="infomation">
      <!-- {{$route.meta.keepAlive}} -->
      <keep-alive>
        <router-view v-if='$route.meta.keepAlive'/>
      </keep-alive>
      <router-view v-if='!$route.meta.keepAlive'/>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {

    }
  },
  mounted(){
    // console.log(this.user)
  },
  computed: {
    user(){
      // console.log(this.$store.getters.);
      return JSON.parse(this.$store.getters.GETUSER)
    }
  },
  methods: {
    getTeacherInfo(){

    }
  }
}
</script>
<style lang="scss" scoped>
.user{display: flex; padding: 50px 0 100px; width: 1200px; margin: 0 auto; align-items: stretch;}
.sidebar{width: 250px; background: #fff; border-radius: 5px; margin-right: 20px;}
.infomation{flex: 1;}
.info{
  margin: 0 50px; padding: 50px 0 0; border-bottom: 1px solid #E9E9E9; text-align: center; height: 233px;
  .name{margin-top: 10px; line-height: 24px; font-size: 18px; color: #0086EA;}
  .level{margin-top: 5px; color: #999;}
}
.avatar{
  width: 80px; height: 80px; border-radius: 50%; overflow: hidden; font-size: 0; margin: 0 auto;
  .img{width: 100%; height: 100%;}
}
.summary{
  margin-top: 10px;
  .cell{margin: 0 5px; color: #666;}
} 
.nav{padding: 60px 0;}
.nav-cell{
  display: block; text-align: center; height: 50px; line-height: 50px; color: #C2C2C2; font-size: 16px;
  &.on{background: rgba(0, 134, 234, .1); color: #0086EA;}
  &:hover{color: #0086EA;}
}
</style>
<i18n>
{
  "cn": {
    "account": "我的帐号",
    "pre": "账户预存",
    "timetable": "我的课表",
    "end": "已上课堂",
    "myStudent": "我的学生",
    "msg": "即时信息",
    "income": "收入管理"
  },
  "TW": {
    "account": "我的帳號",
    "pre": "帳戶預存",
    "timetable": "我的課表",
    "end": "已上課堂",
    "myStudent": "我的學生",
    "msg": "即时信息",
    "income": "收入管理"
  },
  "en": {
    "account": "My account",
    "pre": "Account credit ",
    "timetable": "My lessons",
    "end": "Completed lessons",
    "myStudent": "My Students",
    "msg": "Messaging",
    "income": "Income management"
  }
}
</i18n>